import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStateService {
  constructor() {}

  public currentStep: ''|'payment'|'confirmation' = '';

  nextStep(step: ''|'payment'|'confirmation'): void {
    this.currentStep = step;
  }

}
